import React from "react";

const TextTemplate = ({ data, value, tableManager }) => {
  const additionalProps = tableManager?.config?.additionalProps?.cell || {};

  const classNames = (
    "rgt-cell-inner rgt-text-truncate justify-content-center " +
    (additionalProps.className || "")
  ).trim();

  const displayValue = value ?? "N/A";

  return (
    <span title={displayValue} className={classNames}>
      {displayValue === "0/0" ? "N/A" : displayValue}
    </span>
  );
};

export default TextTemplate;
